import defaultLogo from '../assets/default-tenant-logo.png';

const fallbackThemeData = {
  config: {
    // Used for the first paint, before /api/v2/auth/tenant-config answers (and
    // whenever it fails). A local copy of the default tenant's logo, so nothing
    // visibly swaps once the API replies — and so the fallback keeps working
    // when the network doesn't.
    branding: {
      brandImage: "",
      favicon: defaultLogo,
      logo: defaultLogo,
      primaryColor: "#1250B2"
    },
    featureToggles: {
      posts: true,
      peopleList: true,
      keywordList: true,
      myPosts: true,
      messaging: true,
      crm: true,
      analytics: true
    }
  },
  domain: "test123.domain.in",
  tenantName: "linkedShip"
};

export default fallbackThemeData;